var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-a pointer"},[_c('p',{staticClass:"type",style:({color: _vm.tagFontColor, backgroundColor: _vm.tagColor})},[_vm._v(_vm._s(_vm.type))]),_c('div',{staticClass:"name"},[_c('p',{staticClass:"font_14_black article-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"font_14_gray time"},[_vm._v(_vm._s(_vm.date))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }